import { render, staticRenderFns } from "./whatsapp-settings.vue?vue&type=template&id=64fc8e3e&scoped=true"
import script from "./whatsapp-settings.vue?vue&type=script&lang=js"
export * from "./whatsapp-settings.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-settings.vue?vue&type=style&index=0&id=64fc8e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc8e3e",
  null
  
)

export default component.exports